import(/* webpackMode: "eager" */ "/vercel/path0/app/(public)/competitions/page.tsx");
